import { mapActions } from 'vuex'
export default {
    props: [
        'fastTrack',
        'noRelatedReference',
        'includeCancelled',
        'onlyCancelled',
        'noFTManualReview',
        'insuranceLineId',
        'insuranceLineIds',
        'portalGroupId',
        'ignoreNoPolicyData',
        'noPolicyData'
    ],
    data() {
        return {
            searchPayload: null,
            orderBy: 'DateCreated',
            sortDirection: 'DESC',

            selectedOrderBy: null,
            orderByOptions: [],

            selectedItems: [],

            showStatus: false,
            showFlag: false,
            showExport: false,
        }
    },
    computed: {
        isLoading() {
            return this.$store.getters.isLoading
        },
        claimsList() {
            return this.$store.getters.claimsList
        },
        taskHistoryList() {
            return this.$store.getters.taskHistoryList
        },
        pageNumber: {
            get() {
                return this.$store.getters.pageNumber
            },
            set(value) {
                this.$store.commit('setPageNumber', value)
            }
        },
        resellers() {
            return this.$store.getters.resellers
        },
        underwriters() {
            return this.$store.getters.underwriters
        },
        taskTypes() {
            return this.$store.getters.taskTypes
        },
        repairProviders() {
            return this.$store.getters.repairProviders
        },
        repairOptionTypes() {
            return this.$store.getters.repairOptionTypes
        },
        incidentTypes() {
            return this.$store.getters.incidentTypesDisplayLabel1
        },
        totalRecords() {
            return this.$store.getters.totalRecords
        },
        routeName() {
            return this.$route.name
        },
        approveRoute() {
            return this.$store.getters.approveRoute(this.routeName)
        },
        pageSize: {
            get() {
                return this.$store.getters.pageSize
            },
            set(value) {
                this.$store.commit('setPageSize', value)
            }
        },
        documentTypes() {
            return this.$store.getters.documentTypes
        },
        manualStatuses() {
            return this.$store.getters.manualStatuses.map(i => { return { value: i, text: i.label } })
        },
        declinationReasons() {
            return this.$store.getters.declinationReasons.map(i => { return { value: i, text: i.label } })
        },
        selectedClaimIndex() {
            return this.$store.getters.selectedClaimIndex
        }
    },
    methods: {
        ...mapActions([
            'fetchClaimsExcessCardPaymentsFilterPagenated',
            'fetchClaimsLatestDocUploadListPagenated',
            'fetchClaimsListPagenated',
            'fetchClaimsSelectedRepairOptionsFilterPagenated',
            'fetchTaskHistoryListPagenated',
            'updateClaims',
            'updateClaimsTaskFlags',
            'updateClaimsDocTaskFlags',
            'updateClaimsPayTaskFlags',
            'updateClaimsRepTaskFlags',
            'fetchSelectedClaim',
            'clearClaimsList',
            'clearSelectedClaim',
            'fetchResellers',
            'fetchIncidentTypes',
            'fetchDeclinationReasons',
            'fetchManualStatuses',
            'fetchDocumentTypes',
            'fetchRepairProviders',
            'fetchRepairOptionTypes',
            'fetchTaskTypes',
            'setSelectedClaimIndex',
            'fetchSelectedClaimEx',
            'fetchUnderwriters',
            'getClaimsListPagenated',
            'getClaimsListPagenatedV2Async'
        ]),
        handleOrderByClick(payload) {
            console.log('handleOrderByClick-PING')
            let { orderBy, direction } = payload
            if ((typeof (orderBy) != 'undefined' && orderBy != null) &&
                (typeof (orderBy) != 'undefined' && orderBy != null)) {

                this.orderBy = orderBy.key
                this.sortDirection = direction
                this.handleSearchClick(this.searchPayload)
            }
        },
        handleItemDblClick({ index, claimId }) {
            this.clearSelectedClaim()
            //this.fetchSelectedClaim(claimId)
            this.fetchSelectedClaimEx(claimId)
            this.setSelectedClaimIndex(index)
            this.$router.push(this.approveRoute)

        },
        buildSearchValues(payload) {
            if (payload != null) {
                let { reseller, claimReference, policyNumber, claimantEmail, incidentDate, incidentType, fastTrackFilter} = payload
                let fastTrack = null

                if (fastTrackFilter) {
                    if (fastTrackFilter.id == 1) {
                        fastTrack = true
                    }

                    if (fastTrackFilter.id == 2) {
                        fastTrack = false
                    }
                }

                let criteria = {
                    resellerId: reseller ? reseller.id : null,
                    claimReference: claimReference,
                    policyNumber: policyNumber,
                    claimantEmail: claimantEmail,
                    incidentDate: incidentDate,
                    incidentTypeId: incidentType ? incidentType.id : null,
                    fastTrack: fastTrack,
                }

                return criteria
            } else {
                return null
            }
        },
        buildSearchCriteria(searchValues, pageNumber) {
            let ordering = {
                orderBy: this.orderBy,
                sortDirection: this.sortDirection
            }

            let pages = {
                pageSize: this.pageSize,
                pageNumber: pageNumber
            }

            let criteria = {
                ...searchValues,
                noRelatedReference: this.noRelatedReference, // hide if has related reference (in EVO)
                noFTManualReview: this.noFTManualReview,
                ...ordering,
                ...pages
            }
            if (!criteria.insuranceLineId) {
                criteria.insuranceLineId = this.insuranceLineId
            }
            if (!criteria.insuranceLineIds) {
                criteria.insuranceLineIds = this.insuranceLineIds
            }

            if (!criteria.hasOwnProperty('ignoreNoPolicyData') || typeof criteria.ignoreNoPolicyData !== 'boolean') {
                criteria.ignoreNoPolicyData = this.ignoreNoPolicyData
            }

            if(!criteria.hasOwnProperty('noPolicyData') || typeof criteria.noPolicyData !== 'boolean') {
                criteria.noPolicyData = this.noPolicyData
            }

            console.log('-c: ', criteria)
            return criteria
        },
        handlePageSizeChange(payload) {
            if (this.claimsList && this.claimsList.length > 0) {
                let criteria = this.buildSearchCriteria(this.buildSearchValues(this.searchPayload))
                this.claimsSearch(criteria, this.pageNumber)
            }
        },
        handleSearchClick(payload) {

            if (payload != null) {
                this.searchPayload = payload

                let criteria = this.buildSearchValues(payload)

                this.claimsSearch(criteria, 1)
            } else {
                this.claimsSearch(null, 1)
            }
        },
        async handleSearchClickEx(payload) {
            let searchRes = null
            let criteria = null

            if (payload != null) {
                this.searchPayload = payload
                criteria = this.buildSearchValues(payload)   
            }

            searchRes = await this.claimsSearchEx(criteria, 1)

            if (searchRes) {
                let { data } = searchRes
                //console.log('-d : ', data)
                if (data) {
                    //console.log('-l : ', data.length)
                    if (data.length == 1) {
                        let { claimId } = data[0]
                        //console.log('-c : ', data[0].claimId)
                        if (!isNaN(claimId)) {
                            this.clearSelectedClaim()
                            this.fetchSelectedClaimEx(claimId)
                            this.setSelectedClaimIndex(0)
                            this.$router.push(this.approveRoute)
                        }
                    }
                }
            }
        },
        handleClearClick() {
            this.searchPayload = null
            this.claimsSearch(null, 1)
        },
        handlePagenationInput(payload) {
            if (this.claimsList && this.claimsList.length > 0) {
                let criteria = this.buildSearchCriteria(this.buildSearchValues(this.searchPayload))
                this.claimsSearch(criteria, payload)
            }
        },
        claimsSearch(searchValues, pageNumber) {
            this.clearClaimsList()

            let criteria = this.buildSearchCriteria(searchValues, pageNumber)

            if (this.fastTrack)
                criteria.fastTrack = this.fastTrack

            this.fetchClaimsListPagenated(criteria)
        },
        async claimsSearchEx(searchValues, pageNumber) {
            this.clearClaimsList()

            let criteria = this.buildSearchCriteria(searchValues, pageNumber)

            if (this.fastTrack)
                criteria.fastTrack = this.fastTrack

            return await this.getClaimsListPagenated(criteria)
        },
        async claimsSearchV2Async(searchValues, pageNumber) {

            let criteria = this.buildSearchCriteria(searchValues, pageNumber)

            if (this.fastTrack)
                criteria.fastTrack = this.fastTrack

            return await this.getClaimsListPagenatedV2Async(criteria)
        },
        handleSelectedItemsChange(payload) {
            this.selectedItems = payload
        },
        handleStatusClick() {
            this.showFlag = false
            this.showExport = false
            this.showStatus = true
        },
        handleTaskClick() {
            this.showFlag = true
            this.showExport = false
            this.showStatus = false
        },
        handleExportClick() {
            this.showFlag = false
            this.showExport = true
            this.showStatus = false
        },
    }
}